import { useEffect, useRef } from "react";

import { TApiButtonCommandFn } from ".";

import { useModal } from "modules";
import { useAppSelector } from "store";

import { findIndex } from "lodash-es";

import { BREAK_ACTIONS } from "../useButtonAction";

export const useFormUnsavedDiffWarning = () => {
  const isFlowFormDirtied = useAppSelector(state => state.formFlow.isFormDirtied);
  const isFormDirtiedRef = useRef(isFlowFormDirtied);
  const openModal = useModal();

  useEffect(() => {
    isFormDirtiedRef.current = isFlowFormDirtied;
  }, [isFlowFormDirtied]);

  const formUnsavedDiffWarningCommand: TApiButtonCommandFn = (_, { actions = [] }) => {
    if (isFormDirtiedRef.current) {
      const indexOfCurrentAction = findIndex(
        actions,
        action => action.command.destination === "formUnsavedDiffWarning"
      );
      const remainingButtonActions = actions.slice(indexOfCurrentAction + 1);

      openModal("ExitWithoutSavingModal", { actions: remainingButtonActions });
      return BREAK_ACTIONS;
    }
  };

  return formUnsavedDiffWarningCommand;
};
